<template>
  <m-modal
    :show="show"
    @close="$emit('close')"
    sidebarHeaderText="Warning"
  >
    <div class="mt-8 mx-auto w-3/4 flex space-x-12">
      <div class="flex items-center">
        <svg class="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
      </div>
      <slot></slot>
    </div>
    <div class="mt-8 flex justify-center space-x-4">
      <m-button variant='secondary' @click="$emit('action', 'cancel')">Cancel</m-button>
      <m-button @click="$emit('action', 'confirm')">Confirm</m-button>
    </div>
  </m-modal>
</template>

<script>
export default {
  name: 'warning-modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>

</style>
